import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-add-action-button',
  templateUrl: './add-action-button.component.html',
  styleUrls: ['./add-action-button.component.scss']
})
export class AddActionButtonComponent {
  @Input() btnName: string = '';
  @Input() label: string = '';
  @Input() isSvgShow: boolean = true;
  @Input() showIcon: boolean = true;
  @Input() disabled: boolean = false;
  @Input() routerLink: string | any[] | null = null;
  @Input() customClass: string = '';

  @Output() btnClick = new EventEmitter<MouseEvent>();
}

